<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 营销模块
        </el-breadcrumb-item>
        <el-breadcrumb-item>促销规则</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="关键字" prop="keyword">
                <el-input v-model="searchform.keyword" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生效时间" prop="datelist">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.datelist"
                  type="daterange"
                  value-format="timestamp"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              <el-button type="primary" @click="update.show=false,add.addshow=!add.addshow">添加规则</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <!--步骤条 填写基础信息 -->
      <add-rule :add="add" :search="search" />
      <Update-Rule :update="update" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>模板列表</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column type="index" label="序号" :index="indexMethod"></el-table-column>
            <el-table-column
              prop="luckydrawRuleName"
              label="规则名称"
              width="160"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="awardObjectTypename"
              label="奖励类型"
              min-width="200"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="luckydrawChanceTypename"
              label="规则类型"
              width="160"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="createDate" label="创建时间" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="barterFlag" label="操作" min-width="80" show-overflow-tooltip>
              <template slot-scope="props">
                <el-button-group>
                  <el-button
                    type="primary"
                    @click="getupdateinfo(props.row),add.addshow=false,update.show =true"
                    icon="el-icon-edit"
                    v-permission="['promotionrule_update']"
                  ></el-button>
                  <el-button
                    type="danger"
                    v-permission="['promotionrule_delete']"
                    icon="el-icon-delete"
                    @click="deletedate(props.row.luckydrawRuleUuid)"
                  ></el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  luckydrawruledelete,
  findlistbyconditions,
  findawardnamebyrule
} from "@/api/market/marketing";
import AddRule from "./components/AddRule";
import UpdateRule from "./components/UpdateRule";
import { get } from "http";
//引入导出组件模块
export default {
  name: "promotionrule",
  components: { AddRule, UpdateRule },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      add: {
        addshow: false
      },
      update: {
        form: {
          luckydrawActivityName: null,
          isTemplate: false,
          awardRemark: null,
          awardObjectType: null,
          luckydrawChanceType: null,
          luckydrawRuleName: null,
          luckydrawRuleDetails: []
        },
        row: {},
        show: false
      },
      awardlist: [],
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        datelist: [],
        keyword: "",
        page: 1,
        rows: 10
      }
    };
  },
  methods: {
    getupdateinfo(row) {
      // 修改按钮
      document.getElementById("A1").scrollIntoView({
        // 锚点定位
        block: "start",
        inline: "nearest",
        behavior: "smooth"
      });
      findawardnamebyrule({ ruleUuid: row.luckydrawRuleUuid }).then(
        // 把奖励明细遍历出来
        response => {
          this.awardlist = response.data;
          for (let i = 0; i < row.luckydrawRuleDetails.length; i++) {
            for (var name in this.awardlist) {
              // 奖励明细赋值
              row.luckydrawRuleDetails[i].awardStuffUuidname = this.awardlist[
                row.luckydrawRuleDetails[i].luckydrawRuleDetailUuid
              ];
            }
            console.log(row.luckydrawRuleDetails[i].awardStuffUuidname);
            switch (row.luckydrawRuleDetails[i].awardStuffType) {
              case 0:
                row.luckydrawRuleDetails[i].awardStuffTypename = "红包";
                break;
              case 1:
                row.luckydrawRuleDetails[i].awardStuffTypename = "积分";
                break;
              case 2:
                row.luckydrawRuleDetails[i].awardStuffTypename = "实物";
                break;
              case 3:
                row.luckydrawRuleDetails[i].awardStuffTypename = "优惠卷";
                break;
              default:
                break;
            }
            switch (row.luckydrawRuleDetails[i].luckydrawChanceType) {
              case 0:
                row.luckydrawRuleDetails[i].luckydrawChanceTypename = "按比例";
                break;
              case 1:
                row.luckydrawRuleDetails[i].luckydrawChanceTypename = "按箱";
                break;
              default:
                break;
            }
          }
          this.update.form = row;
          this.update.row = row;
        }
      );
    },
    next() {
      // 步骤条
      this.show = !this.show;
      if (this.active++ >= 2) {
        this.active = 1;
      }
    },
        // 计算序号方法
        indexMethod(index) {
         let tamp = (this.searchform.page *this.searchform.rows)-this.searchform.rows+1;
        return index + tamp;
      },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      findlistbyconditions(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        // obj[i].createDate = obj[i].createDate.replace(/T/, " ").substring(0,obj[i].createDate.length-9);
        switch (Number(obj[i].awardObjectType)) {
          case 1:
            obj[i].awardObjectTypename = "消费者/一般厨师";
            break;
          case 2:
            obj[i].awardObjectTypename = "终端厨师长";
            break;
          case 3:
            obj[i].awardObjectTypename = "分销商";
            break;
          case 4:
            obj[i].awardObjectTypename = "经销商";
            break;
          case 5:
            obj[i].awardObjectTypename = "企业用户";
            break;
          default:
            break;
        }
        switch (obj[i].luckydrawChanceType) {
          case 0:
            obj[i].luckydrawChanceTypename = "按比例";
            break;
          case 1:
            obj[i].luckydrawChanceTypename = "按箱";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        beginDate: this.searchform.datelist[0] || null,
        endDate: this.searchform.datelist[1] || null,
        keyword: this.searchform.keyword,
        page: this.searchform.page,
        rows: this.searchform.rows
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.page = currPage;
      this.Tabledata({
        sproduceTime: this.searchform.datelist[0] || null,
        eproduceTime: this.searchform.datelist[1] || null,
        orderno: this.searchform.orderno,
        page: this.searchform.page,
        rows: this.searchform.rows
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.rows = pageSize;
      this.search();
    },
    //删除按钮事件
    deletedate(obj) {
      this.$confirm("此操作将永久删除该规则信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          luckydrawruledelete({
            uuid: obj
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>